import styled, { css } from 'styled-components';
import { colors, radius } from '../../styles/tokens';

interface IContainerProps {
  isMain: boolean;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  align-items: center;
  gap: 4px;

  width: min-content;
  white-space: nowrap;

  padding: 6px 12px;
  border-radius: ${radius.full};

  ${props =>
    props.isMain
      ? css`
          background: linear-gradient(
            135deg,
            ${colors.primary} 0%,
            ${colors.primaryContainer} 100%
          );
          color: ${colors.onPrimary};
        `
      : css`
          background-color: ${colors.surfaceContainerHighest};
          color: ${colors.onSurfaceVariant};
        `}
`;

export const ContainerLabel = styled.div`
  display: flex;
  cursor: pointer;
`;

export const Label = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const ButtonClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;

  color: currentColor;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;
